import { render } from "./UserDetailsSpan.vue?vue&type=template&id=7e343449"
import script from "./UserDetailsSpan.vue?vue&type=script&lang=js"
export * from "./UserDetailsSpan.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__